import { CalendarPrintWeekLayoutPageBase } from './CalendarPrintWeekLayoutPage.base';
import type {
    CalendarPrintWeekLayoutPageProps,
    CalendarPrintWeekLayoutPageStyleProps,
    CalendarPrintWeekLayoutPageStyles,
} from './CalendarPrintWeekLayoutPage.types';
import { styled } from '@fluentui/react/lib/Utilities';
import { getPalette } from 'owa-theme';
export type { CalendarPrintWeekLayoutPageProps };
import { FontWeights } from '@fluentui/style-utilities';

/** The default style of CalendarPrintWeekLayoutPage */
export function getStyles(
    styleProps: Required<CalendarPrintWeekLayoutPageStyleProps>
): CalendarPrintWeekLayoutPageStyles {
    const palette = getPalette();
    return {
        root: [
            'ms-CalendarPrintWeekLayoutPage',
            styleProps.className,
            {
                height: '100%',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                flex: '1 1 auto',
                border: '1px solid ' + palette.neutralTertiaryAlt,
                boxSizing: 'border-box',
            },
        ],
        row: {
            minHeight: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'row',
            flex: '1 1 auto',
            boxSizing: 'border-box',
            selectors: {
                ':not(:last-child)': {
                    borderBottom: '1px solid ' + palette.neutralTertiaryAlt,
                },
            },
        },
        cell: {
            minHeight: 0,
            overflow: 'hidden',
            flex: '1 1 auto',
            flexDirection: 'column',
            display: 'flex',
            boxSizing: 'border-box',
            width: '100%',
            selectors: {
                ':not(:last-child)': {
                    borderRight: '1px solid ' + palette.neutralTertiaryAlt,
                },
            },
        },
        subcell: {
            height: '50%',
            overflow: 'hidden',
            flex: '1 1 auto',
            flexDirection: 'column',
            display: 'flex',
            boxSizing: 'border-box',
            selectors: {
                ':not(:last-child)': {
                    borderBottom: '1px solid ' + palette.neutralTertiaryAlt,
                },
            },
        },
        cellHeader: {
            margin: '4px 0 0 4px',
            fontSize: 16,
        },
        eventWrapper: {
            display: 'flex',
            margin: '2px 4px',
        },
        eventContentWrapper: {
            display: 'flex',
            overflow: 'hidden',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            fontSize: 13,
            selectors: {
                '& span': {
                    marginLeft: 4,
                },
            },
        },
        mainEventContent: {
            fontWeight: FontWeights.semibold,
        },
    };
}

/** The default styled version of CalendarPrintWeekLayoutPage */
export const CalendarPrintWeekLayoutPage = styled<
    CalendarPrintWeekLayoutPageProps<{}>,
    Required<CalendarPrintWeekLayoutPageStyleProps>,
    CalendarPrintWeekLayoutPageStyles
>(CalendarPrintWeekLayoutPageBase, getStyles) as typeof CalendarPrintWeekLayoutPageBase;
